/**
 * How a row color is drawn (087).
 *
 * One mid-tone per color, mixed into the row's own surface rather than
 * painted over it: 14% of the color reads as a tint on the light theme and
 * on the dark one without either needing its own palette, and the text on
 * top keeps its contrast. The leading edge takes the color at full strength,
 * so a color is still there to see when the row is the one under the cursor.
 */
import type { RowColor } from '@esa/shared';

export const ROW_COLOR_HEX: Record<RowColor, string> = {
  pink: '#e0559b',
  red: '#dc4c4c',
  orange: '#e8833a',
  yellow: '#d4a514',
  green: '#3fa66b',
  teal: '#2aa3a3',
  blue: '#3b82f6',
  purple: '#8b5cf6',
  grey: '#8a8f98',
};

export const ROW_COLOR_LABEL: Record<RowColor, string> = {
  pink: 'Pink',
  red: 'Red',
  orange: 'Orange',
  yellow: 'Yellow',
  green: 'Green',
  teal: 'Teal',
  blue: 'Blue',
  purple: 'Purple',
  grey: 'Grey',
};

/** For the glass theme, whose cells are clear: the color alone, see-through. */
export function rowTintClear(color: RowColor): string {
  return `color-mix(in srgb, ${ROW_COLOR_HEX[color]} 18%, transparent)`;
}

/** The row's background: its surface with a share of the color in it. */
export function rowTint(color: RowColor): string {
  return `color-mix(in srgb, ${ROW_COLOR_HEX[color]} 14%, rgb(var(--surface)))`;
}
